/**
 * ZoneAlarm Style01 - Stitch v1: card + device name, ARMED + 光暈光點
 */
import type { TraitControlProps } from './types'
import { getTraitConfig } from './traitStyleConfig'
import './ZoneAlarmStyle01.css'

export function ZoneAlarmStyle01({ device, state }: TraitControlProps) {
  const { icon } = getTraitConfig('ZoneAlarm')
  const deviceName = (device?.nickname && String(device.nickname).trim()) || 'Zone Alarm'
  const armed = (state?.armed ?? state?.alarmState ?? state?.status) as boolean | string | undefined
  const isArmed = armed === true || armed === 'ARMED' || armed === 'armed' || String(armed).toLowerCase() === 'true'
  const stateToken = isArmed ? 'on armed' : 'off disarmed'

  return (
    <div
      className="trait-zonealarm-style01 trait-stitch-glass"
      data-css-slot="alarmSurface"
      data-css-slot-label="Alarm Surface"
      data-css-state={stateToken}
    >
      <div className="trait-zonealarm-style01__content">
        <span
          className="trait-zonealarm-style01__name"
          data-css-slot="alarmName"
          data-css-slot-label="Alarm Name"
          data-css-state={stateToken}
        >
          {deviceName}
        </span>
        <span
          className={`trait-zonealarm-style01__status ${isArmed ? 'armed' : ''}`}
          data-css-slot="alarmStatus"
          data-css-slot-label="Alarm Status"
          data-css-state={stateToken}
        >
          {isArmed ? 'ARMED' : 'DISARMED'}
        </span>
      </div>
      <div className="trait-zonealarm-style01__indicator">
        <span
          className={`material-symbols-outlined trait-zonealarm-style01__icon ${isArmed ? 'armed' : ''}`}
          aria-hidden
          data-css-slot="alarmIcon"
          data-css-slot-label="Alarm Icon"
          data-css-state={stateToken}
        >
          {icon}
        </span>
      </div>
    </div>
  )
}
